export enum CurrencyType {
  CHF = "CHF",
  EUR = "EUR",
  USD = "USD",
}

/**
 * Montants pré-calculés par le backend pour les factures/offres multi-devises.
 *
 * SOURCE DE VÉRITÉ pour tous les montants convertis en devise principale (pc).
 * Les valeurs sont calculées côté backend par Invoice.calc_pc() avec les bons
 * arrondis (arrondi au 5 centimes suisse via round_total_pt).
 *
 * Glossaire :
 *   pc = Primary Currency (devise principale de l'entreprise, ex: CHF)
 *   fc = Foreign Currency (devise de la facture si différente, ex: EUR)
 *   bt = Before Tax (HT net, après remises)
 *   pt = Plus Tax (TTC)
 *
 * Accès via les getters Invoice (préférer ces getters aux champs directs) :
 *   cd_fc_rate                    → fc_rate
 *   cd_gross_total_price_pc       → gross_total_price_pc
 *   cd_total_bt_pc                → total_bt_pc
 *   cd_vat_amount_pc              → vat_amount_pc
 *   cd_total_pt_pc                → total_pt_pc
 *   cd_paid_gross_total_price_pc  → paid_gross_total_price_pc
 *   cd_paid_vat_amount_pc         → paid_vat_amount_pc
 *   cd_paid_total_pt_pc           → paid_total_pt_pc
 *
 * Méthodes Invoice recommandées :
 *   getNetTotalPricePc()          → net HT en pc (utilise cd_total_bt_pc)
 *   getNetVatTotalPricePc()       → TTC en pc (utilise cd_total_pt_pc)
 *   getNetVatRealTotalPricePc()   → TTC réel en pc (payé si PAID, sinon facturé)
 *   getNetRealPricePc()           → HT réel en pc (payé si PAID, sinon facturé)
 *
 * ANTI-PATTERNS (DEPRECATED — génèrent des écarts d'arrondis de centimes) :
 *   ❌ montant * getRateCurrency(primaryCurrency) → ✅ méthode *Pc()
 *   ❌ paid_gross_total_price * (1 + vat_rate/100) → ✅ paid_total_pt
 *   ❌ netVatTotalPrice * getRateCurrency()        → ✅ getNetVatTotalPricePc()
 *   ❌ netTotalPrice * getRateCurrency()            → ✅ getNetTotalPricePc()
 *   ❌ paid_total_pt * getRateCurrency()            → ✅ cd_paid_total_pt_pc
 *   ❌ paid_gross_total_price * getRateCurrency()   → ✅ cd_paid_gross_total_price_pc
 */
export class CurrencyDetails {
  /** Taux de conversion fc → pc (ex: 1.08 si 1 EUR = 1.08 CHF) */
  fc_rate: number;

  /** Montant brut HT en pc (avant remises) */
  gross_total_price_pc: number;
  /** TVA en pc */
  vat_amount_pc: number;
  /** Total TTC en pc (arrondi 5 centimes suisse) */
  total_pt_pc: number;
  /** Total net HT en pc (après remises et avoirs) */
  total_bt_pc: number;

  /** Montant payé HT en pc */
  paid_gross_total_price_pc: number;
  /** TVA payée en pc */
  paid_vat_amount_pc: number;
  /** Total payé TTC en pc */
  paid_total_pt_pc: number;

  /** Montant brut HT en devise étrangère (fc) */
  gross_total_price_fc: number;

  constructor() {
    this.fc_rate = 1;
    this.gross_total_price_pc = 0.0;
    this.vat_amount_pc = 0.0;
    this.total_pt_pc = 0.0;
    this.total_bt_pc = 0.0;

    this.paid_gross_total_price_pc = 0.0;
    this.paid_vat_amount_pc = 0.0;
    this.paid_total_pt_pc = 0.0;

    this.gross_total_price_fc = 0.0;
  }

  public static createInstance(jsonData: CurrencyDetails): CurrencyDetails {
    const c = Object.assign(new CurrencyDetails(), jsonData);

    return c;
  }
}
